/* eslint no-template-curly-in-string: 0 */
import { HTTP_REQUEST_TYPES, ERROR_TYPES, FLOW_TYPES } from "../../utils/enums";

const finixLogo = require("../../assets/images/visa_mc_logo.png");

export const finix = {
  id: "OCT_FINIX",
  displayName: "Debit Card Balance",
  paymentFlow: "oct",
  cssClassPrefix: "bank",
  errors: {
    uiErrors: {
      [ERROR_TYPES.UI_ERRORS.FAILED_PAYMENT]: {
        title: "Error Transferring Funds",
        description: "An error occurred in processing the payment to your card. Please try again using a different card or payment method.",
      },
      [ERROR_TYPES.UI_ERRORS.OCT_ERROR]: {
        title: "Card Not Supported",
        description: "Unfortunately we can’t complete payment with this card because of bank/ATM network issues, or this is a credit card. Please try another US-issued ATM debit card.",
      }
    },
    byHttpRequestTypeAndResponseStatus: {
      [HTTP_REQUEST_TYPES.RECIPIENT_LOGIN]: {
        default: {
          props: {
            title: "Card Failed",
            showServerErrorMessage: true,
          }
        }
      },
      [HTTP_REQUEST_TYPES.ACCEPT_PAYMENT]: {
        default: {
          props: {
            title: "Error Transferring Funds",
            description: "An error occurred in processing the payment to your card. Please try again using a different card or payment method.",
            showServerErrorMessage: true,
          }
        }
      }
    },
    acceptPayment: {
      title: "Error Transferring Funds",
      message: "An error occurred in processing the payment to your card. Please try again using a different card or payment method."
    }
  },
  paywall: {
    disabledPaymentNetwork: {
      title: 'Endpoint Not Live',
      description: 'For this trial program, ${paymentNetwork.displayName} is only listed as an example of the 250+ options DigitalPay currently offers.  Click the button below to go back and select a live network. Live networks are not “grayed out.”'
    },
    tile: {
      displayName: ["Direct to Bank Account"],
      tagline: [
        {
          string: "Use your debit card to securely receive funds",
        }
      ],
      description: [
        {
          string: "Use your debit card number to receive",
          type: "div",
        },
        {
          string: "funds in your bank account",
          type: "div"
        }
      ],
      // btnLabel: "Next",
      logo: finixLogo,
    }
  },
  recipientLogin: {
    flow: 'finix',
    title: ["Direct to Bank"],
    description: "Your card information is being processed safely by Visa and is not collected by ${programName}",
    errors: {
      400: {
        title: 'Card Failed',
        message: "An error occurred in processing the payment to your card. Please try again using a different card or payment method.",
      }
    },
    props: {
      acceptedCardTypes: {
        cardTypes: ['visa', 'mastercard'],
        errorMessage: 'You must use a Visa or Mastercard',
      },
    },
  },
  acceptPayment: {
    flow: FLOW_TYPES.ACCEPT_PAYMENT.FINIX,
    description: [
      "You have chosen to add ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " directly to your debit card balance."
    ],
    imgSrc: finixLogo,
    acceptPaymentButtons: [
      {
        btnLabel: "Apply to Debit Card Balance"
      }
    ],
    disclaimerHtmlString: null
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! A payment of ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " has been deposited to your debit card balance."
      ]
    },
    revisit: {
      description: [
        "Your payment of ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " was deposited to your debit card balance on ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: 'payment-updatedAt'
          }
        },
        "."
      ]
    },
    imgSrc: finixLogo,
    paymentCompleteButtons: [],
  },
  onHold: {
    imgSrc: finixLogo,
  }
};

export default finix;
